import _styled from "styled-components";
import React, { useCallback, useState } from 'react';
import Image from 'next/image';
import { PhotoIcon } from '@heroicons/react/24/solid';
import { DevicePhoneMobileIcon, MapPinIcon } from '@heroicons/react/24/outline';
import { customImageLoader, FireIcon, useResponsiveBreakPoints } from '@restworld/utils-common';
import { Badge, IconButton } from '@restworld/ui-ds-base';
import Title from '../title';
import { ButtonV2 } from '../button-v2';
import { WhatsappIcon } from '@restworld/utils-common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function EmployerCandidateCard(_ref) {
  var children = _ref.children,
      ctaButton = _ref.ctaButton,
      twStyle = _ref.twStyle,
      newShortlistedSection = _ref.newShortlistedSection;

  var _useState = useState(false),
      isHovered = _useState[0],
      setIsHovered = _useState[1];

  var _useResponsiveBreakPo = useResponsiveBreakPoints(),
      isDesktop = _useResponsiveBreakPo.isDesktop;

  return /*#__PURE__*/_jsxs(CardContainer, {
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    },
    onClick: ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.onClick,
    twStyle: twStyle,
    children: [children, (isDesktop || newShortlistedSection) && /*#__PURE__*/_jsx(CardFooterWrapper, {
      isHovered: newShortlistedSection ? true : isHovered,
      children: /*#__PURE__*/_jsx(ButtonV2, {
        fullwidth: true,
        size: "sm",
        children: ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.label
      })
    })]
  });
}
export function EmployerCandidateCardHeader(_ref2) {
  var firstName = _ref2.firstName,
      lastName = _ref2.lastName;

  var truncateText = function truncateText(text) {
    var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 35;
    if (!text) return text;
    return text.length > maxLength ? "".concat(text.slice(0, maxLength), "...") : text;
  };

  return /*#__PURE__*/_jsxs(CardHeaderWrapper, {
    children: [/*#__PURE__*/_jsx(Title, {
      fontSize: "small",
      fontWeight: "semibold",
      twStyle: {
        "fontSize": "0.875rem",
        "lineHeight": "1.5",
        "--tw-text-opacity": "1",
        "color": "rgb(28 28 51 / var(--tw-text-opacity))"
      },
      children: truncateText(firstName)
    }), /*#__PURE__*/_jsx(Title, {
      fontSize: "small",
      fontWeight: "semibold",
      twStyle: {
        "fontSize": "0.875rem",
        "lineHeight": "1.5",
        "--tw-text-opacity": "1",
        "color": "rgb(28 28 51 / var(--tw-text-opacity))"
      },
      children: truncateText(lastName)
    })]
  });
}
export function EmployerCandidateCardInfo(_ref3) {
  var candidateImage = _ref3.candidateImage,
      badge = _ref3.badge,
      distance = _ref3.distance,
      showFire = _ref3.showFire;
  return /*#__PURE__*/_jsxs(CardInfoWrapper, {
    children: [/*#__PURE__*/_jsxs(RowImageBadgeContainer, {
      children: [/*#__PURE__*/_jsx(CandidateImageWrapper, {
        children: candidateImage ? /*#__PURE__*/_jsx(_StyledImage, {
          src: candidateImage || '',
          alt: "",
          fill: true,
          loader: customImageLoader
        }) : /*#__PURE__*/_jsx(CandidateImagePlaceholder, {})
      }), showFire && /*#__PURE__*/_jsx(FireBadge, {
        children: /*#__PURE__*/_jsx(_StyledFireIcon, {})
      })]
    }), /*#__PURE__*/_jsxs(BadgeAndDistanceWrapper, {
      children: [/*#__PURE__*/_jsx(BadgeWrapper, {
        children: /*#__PURE__*/_jsx(Badge, {
          variant: badge.variant,
          children: "".concat(badge.text, " ").concat(badge.variant === 'fresh' ? '🎉' : '')
        })
      }), /*#__PURE__*/_jsx(DistanceWrapper, {
        children: distance && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(_StyledMapPinIcon, {}), /*#__PURE__*/_jsx(DistanceText, {
            children: distance
          })]
        })
      })]
    })]
  });
}
export function EmployerCandidatesCardLabels(_ref4) {
  var labels = _ref4.labels,
      variant = _ref4.variant;
  return /*#__PURE__*/_jsx(LabelsWrapper, {
    children: labels.map(function (label, i) {
      return label ? /*#__PURE__*/_jsx(BadgeWrapper, {
        children: /*#__PURE__*/_jsx(Badge, {
          variant: variant,
          children: label
        })
      }, i) : null;
    })
  });
}

var CandidateImagePlaceholder = function CandidateImagePlaceholder() {
  return /*#__PURE__*/_jsx(CandidateImagePlaceholderWrapper, {
    children: /*#__PURE__*/_jsx(_StyledPhotoIcon, {})
  });
};

export default EmployerCandidateCard; // New Row-direction variants for JP dashboard shortlisted section

export function EmployerCandidateRowCard(_ref5) {
  var children = _ref5.children,
      ctaButton = _ref5.ctaButton,
      twStyle = _ref5.twStyle,
      footerSlot = _ref5.footerSlot;

  var _useState2 = useState(false),
      isHovered = _useState2[0],
      setIsHovered = _useState2[1];

  var _useResponsiveBreakPo2 = useResponsiveBreakPoints(),
      isDesktop = _useResponsiveBreakPo2.isDesktop;

  return /*#__PURE__*/_jsxs(RowCardContainer, {
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    },
    onClick: ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.onClick,
    twStyle: twStyle,
    children: [children, isDesktop && /*#__PURE__*/_jsx(RowCtaWrapper, {
      isHovered: isHovered,
      children: /*#__PURE__*/_jsx(ButtonV2, {
        twStyle: {
          "height": "3rem !important"
        },
        size: "sm",
        children: ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.label
      })
    }), footerSlot]
  });
}
export function EmployerCandidateRowInfo(_ref6) {
  var firstName = _ref6.firstName,
      lastName = _ref6.lastName,
      badge = _ref6.badge,
      candidateImage = _ref6.candidateImage,
      showFire = _ref6.showFire;

  var truncateText = function truncateText(text) {
    var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;
    if (!text) return text;
    return text.length > maxLength ? "".concat(text.slice(0, maxLength), "...") : text;
  };

  return /*#__PURE__*/_jsxs(RowInfoWrapper, {
    children: [/*#__PURE__*/_jsxs(RowImageBadgeContainer, {
      children: [/*#__PURE__*/_jsx(RowCandidateImageWrapper, {
        children: candidateImage ? /*#__PURE__*/_jsx(_StyledImage2, {
          src: candidateImage || '',
          alt: "",
          fill: true,
          loader: customImageLoader
        }) : /*#__PURE__*/_jsx(CandidateImagePlaceholder, {})
      }), showFire && /*#__PURE__*/_jsx(FireBadge, {
        children: /*#__PURE__*/_jsx(_StyledFireIcon2, {})
      })]
    }), /*#__PURE__*/_jsxs(_StyledDiv, {
      children: [/*#__PURE__*/_jsx(Title, {
        fontSize: "small",
        fontWeight: "semibold",
        twStyle: {
          "fontSize": "0.875rem",
          "lineHeight": "1.5",
          "--tw-text-opacity": "1",
          "color": "rgb(28 28 51 / var(--tw-text-opacity))"
        },
        children: truncateText(firstName)
      }), /*#__PURE__*/_jsx(Title, {
        fontSize: "small",
        fontWeight: "semibold",
        twStyle: {
          "fontSize": "0.875rem",
          "lineHeight": "1.5",
          "--tw-text-opacity": "1",
          "color": "rgb(28 28 51 / var(--tw-text-opacity))"
        },
        children: truncateText(lastName)
      }), /*#__PURE__*/_jsx(Badge, {
        variant: badge.variant,
        children: "".concat(badge.text, " ").concat(badge.variant === 'fresh' ? '🎉' : '')
      })]
    })]
  });
}
export function EmployerCandidateRowDistance(_ref7) {
  var distance = _ref7.distance;
  if (!distance) return null;
  return /*#__PURE__*/_jsxs(RowDistanceWrapper, {
    children: [/*#__PURE__*/_jsx(_StyledMapPinIcon2, {}), /*#__PURE__*/_jsx(DistanceText, {
      children: distance
    })]
  });
}
export function EmployerCandidateRowLabels(_ref8) {
  var labels = _ref8.labels;
  var validLabels = (labels || []).filter(Boolean);
  var maxVisible = 5;
  var visibleLabels = validLabels.slice(0, maxVisible);
  var remainingCount = validLabels.length - visibleLabels.length;
  return /*#__PURE__*/_jsxs(RowLabelsWrapper, {
    children: [visibleLabels.map(function (label, i) {
      return /*#__PURE__*/_jsx(BadgeWrapper, {
        children: /*#__PURE__*/_jsx(Badge, {
          variant: "neutral",
          children: label
        })
      }, i);
    }), remainingCount > 0 && /*#__PURE__*/_jsx(BadgeWrapper, {
      children: /*#__PURE__*/_jsx(Badge, {
        variant: "neutral",
        children: "+".concat(remainingCount)
      })
    })]
  });
}
export function EmployerCandidateRowContact(_ref9) {
  var phoneNumber = _ref9.phoneNumber,
      whatsappNumber = _ref9.whatsappNumber;
  var onPhoneClick = useCallback(function () {
    window.location.href = "tel:".concat(phoneNumber);
  }, [phoneNumber]);
  var onWhatsappClick = useCallback(function () {
    window.open("https://wa.me/".concat(whatsappNumber), '_blank', 'noopener,noreferrer');
  }, [whatsappNumber]);
  return /*#__PURE__*/_jsxs(RowContactWrapper, {
    children: [phoneNumber && /*#__PURE__*/_jsx(_StyledIconButton, {
      ariaLabel: "call",
      Icon: DevicePhoneMobileIcon,
      onClick: onPhoneClick
    }), whatsappNumber && /*#__PURE__*/_jsx(_StyledIconButton2, {
      ariaLabel: "whatsapp",
      Icon: WhatsappIcon,
      onClick: onWhatsappClick
    })]
  });
}

var CardContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__CardContainer",
  componentId: "sc-1ono913-0"
})(["", " ", " ", " ", ""], {
  "position": "relative",
  "boxSizing": "border-box",
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.75rem",
  "borderRadius": "1rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingBottom": "1rem",
  "paddingTop": "1.25rem",
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "150ms",
  ":hover": {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(102 51 187 / var(--tw-border-opacity))",
    "--tw-shadow": "inset 0 0 0 3px #6633bb",
    "--tw-shadow-colored": "inset 0 0 0 3px var(--tw-shadow-color)",
    "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
  }
}, {
  "width": "100%"
}, function (_ref10) {
  var twStyle = _ref10.twStyle;
  return twStyle ? twStyle : {};
}, {
  "cursor": "pointer"
});

var CardHeaderWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__CardHeaderWrapper",
  componentId: "sc-1ono913-1"
})(["", ""], {});

var CardInfoWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__CardInfoWrapper",
  componentId: "sc-1ono913-2"
})(["", ""], {
  "marginBottom": "0.25rem",
  "display": "flex",
  "gap": "0.75rem"
});

var CandidateImageWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__CandidateImageWrapper",
  componentId: "sc-1ono913-3"
})(["", ""], {
  "position": "relative",
  "display": "flex",
  "height": "4rem",
  "width": "4rem",
  "minWidth": "4rem",
  "alignItems": "center",
  "justifyContent": "center",
  "overflow": "hidden",
  "borderRadius": "0.5rem",
  "objectFit": "cover",
  "objectPosition": "center"
});

var CandidateImagePlaceholderWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__CandidateImagePlaceholderWrapper",
  componentId: "sc-1ono913-4"
})(["", ""], {
  "zIndex": "5",
  "display": "grid",
  "height": "4rem",
  "width": "4rem",
  "placeItems": "center",
  "borderRadius": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(240 235 248 / var(--tw-bg-opacity))"
});

var BadgeAndDistanceWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__BadgeAndDistanceWrapper",
  componentId: "sc-1ono913-5"
})(["", ""], {});

var BadgeWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__BadgeWrapper",
  componentId: "sc-1ono913-6"
})(["", ""], {
  "minWidth": "fit-content",
  "maxWidth": "fit-content",
  "whiteSpace": "nowrap"
});

var CardFooterWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__CardFooterWrapper",
  componentId: "sc-1ono913-7"
})(["", " ", ""], {
  "position": "absolute",
  "bottom": "0.5rem",
  "left": "3px",
  "right": "3px",
  "zIndex": "5",
  "display": "grid",
  "height": "3.75rem",
  "placeItems": "center",
  "borderBottomRightRadius": "1rem",
  "borderBottomLeftRadius": "1rem",
  "borderTopWidth": "1px",
  "--tw-border-opacity": "1",
  "borderTopColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "opacity": "0",
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "200ms"
}, function (_ref11) {
  var isHovered = _ref11.isHovered;
  return isHovered ? {
    "bottom": "3px",
    "opacity": "1"
  } : {};
});

var DistanceWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__DistanceWrapper",
  componentId: "sc-1ono913-8"
})(["", ""], {
  "marginTop": "0.5rem",
  "display": "flex",
  "alignItems": "center"
});

var DistanceText = /*#__PURE__*/_styled.p.withConfig({
  displayName: "employer-candidate-card__DistanceText",
  componentId: "sc-1ono913-9"
})(["", ""], {
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(102 102 118 / var(--tw-text-opacity))"
});

var LabelsWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__LabelsWrapper",
  componentId: "sc-1ono913-10"
})(["", ""], {
  "display": "flex",
  "flexWrap": "wrap",
  "gap": "0.25rem"
}); // Row variant styled components


var RowCardContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__RowCardContainer",
  componentId: "sc-1ono913-11"
})(["", " ", " ", " ", ""], {
  "position": "relative",
  "boxSizing": "border-box",
  "display": "grid",
  "gridTemplateColumns": "repeat(9, minmax(0, 1fr))",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "1rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
  "paddingLeft": "1.25rem",
  "paddingRight": "1.25rem",
  "paddingTop": "1rem",
  "paddingBottom": "1rem",
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "150ms",
  ":hover": {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(102 51 187 / var(--tw-border-opacity))",
    "--tw-shadow": "inset 0 0 0 3px #6633bb,0px 4px 16px 0px rgba(0,0,26,0.15)",
    "--tw-shadow-colored": "inset 0 0 0 3px var(--tw-shadow-color), 0px 4px 16px 0px var(--tw-shadow-color)",
    "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
  }
}, {
  "width": "100%"
}, function (_ref12) {
  var twStyle = _ref12.twStyle;
  return twStyle ? twStyle : {};
}, {
  "cursor": "pointer"
});

var RowCandidateImageWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__RowCandidateImageWrapper",
  componentId: "sc-1ono913-12"
})(["", ""], {
  "position": "relative",
  "display": "flex",
  "height": "4rem",
  "width": "4rem",
  "minWidth": "4rem",
  "alignItems": "center",
  "justifyContent": "center",
  "overflow": "hidden",
  "borderRadius": "0.5rem",
  "objectFit": "cover",
  "objectPosition": "center"
});

var RowImageBadgeContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__RowImageBadgeContainer",
  componentId: "sc-1ono913-13"
})(["", ""], {
  "position": "relative",
  "display": "inline-block"
});

var FireBadge = /*#__PURE__*/_styled.span.withConfig({
  displayName: "employer-candidate-card__FireBadge",
  componentId: "sc-1ono913-14"
})(["", ""], {
  "pointerEvents": "none",
  "position": "absolute",
  "top": "-0.5rem",
  "right": "-0.5rem",
  "zIndex": "10",
  "fontSize": "1rem",
  "lineHeight": "1.5rem"
});

var RowInfoWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__RowInfoWrapper",
  componentId: "sc-1ono913-15"
})(["", ""], {
  "gridColumn": "span 2 / span 2",
  "display": "flex",
  "minWidth": "10rem",
  "flexDirection": "row",
  "gap": "0.5rem"
});

var RowDistanceWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__RowDistanceWrapper",
  componentId: "sc-1ono913-16"
})(["", ""], {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "0.25rem"
});

var RowLabelsWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__RowLabelsWrapper",
  componentId: "sc-1ono913-17"
})(["", ""], {
  "gridColumn": "span 5 / span 5",
  "display": "flex",
  "flexWrap": "wrap",
  "gap": "0.5rem"
});

var RowContactWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__RowContactWrapper",
  componentId: "sc-1ono913-18"
})(["", ""], {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "1.5rem"
});

var RowCtaWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-candidate-card__RowCtaWrapper",
  componentId: "sc-1ono913-19"
})(["", " ", ""], {
  "transitionProperty": "opacity",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "200ms"
}, function (_ref13) {
  var isHovered = _ref13.isHovered;
  return isHovered ? {
    "opacity": "1"
  } : {
    "opacity": "0"
  };
});

var _StyledImage = /*#__PURE__*/_styled(Image).withConfig({
  displayName: "employer-candidate-card___StyledImage",
  componentId: "sc-1ono913-20"
})({
  "objectFit": "cover",
  "objectPosition": "center"
});

var _StyledFireIcon = /*#__PURE__*/_styled(FireIcon).withConfig({
  displayName: "employer-candidate-card___StyledFireIcon",
  componentId: "sc-1ono913-21"
})({
  "height": "1.5rem",
  "width": "1.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(158 84 0 / var(--tw-text-opacity))"
});

var _StyledMapPinIcon = /*#__PURE__*/_styled(MapPinIcon).withConfig({
  displayName: "employer-candidate-card___StyledMapPinIcon",
  componentId: "sc-1ono913-22"
})({
  "height": "1rem",
  "width": "1rem",
  "stroke": "#666676"
});

var _StyledPhotoIcon = /*#__PURE__*/_styled(PhotoIcon).withConfig({
  displayName: "employer-candidate-card___StyledPhotoIcon",
  componentId: "sc-1ono913-23"
})({
  "height": "1.5rem",
  "width": "1.5rem",
  "fill": "#482485"
});

var _StyledImage2 = /*#__PURE__*/_styled(Image).withConfig({
  displayName: "employer-candidate-card___StyledImage2",
  componentId: "sc-1ono913-24"
})({
  "objectFit": "cover",
  "objectPosition": "center"
});

var _StyledFireIcon2 = /*#__PURE__*/_styled(FireIcon).withConfig({
  displayName: "employer-candidate-card___StyledFireIcon2",
  componentId: "sc-1ono913-25"
})({
  "height": "1.5rem",
  "width": "1.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(158 84 0 / var(--tw-text-opacity))"
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "employer-candidate-card___StyledDiv",
  componentId: "sc-1ono913-26"
})({
  "display": "flex",
  "flexDirection": "column"
});

var _StyledMapPinIcon2 = /*#__PURE__*/_styled(MapPinIcon).withConfig({
  displayName: "employer-candidate-card___StyledMapPinIcon2",
  componentId: "sc-1ono913-27"
})({
  "height": "1rem",
  "width": "1rem",
  "stroke": "#666676"
});

var _StyledIconButton = /*#__PURE__*/_styled(IconButton).withConfig({
  displayName: "employer-candidate-card___StyledIconButton",
  componentId: "sc-1ono913-28"
})({
  "display": "grid",
  "placeItems": "center"
});

var _StyledIconButton2 = /*#__PURE__*/_styled(IconButton).withConfig({
  displayName: "employer-candidate-card___StyledIconButton2",
  componentId: "sc-1ono913-29"
})({
  "display": "grid",
  "placeItems": "center"
});